import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import QboProductsAccountSettings from "../Components/Forms/ProductSettings.jsx";
import QboCustomerSettings from "../Components/Forms/CustomerSettings";
import QboInvoiceAccountSettings from "../Components/Forms/InvoiceSettings";
import { API_BASE_URL, QBO_APP_BASE_URL } from "../utils/constants";
import axios from "axios";
import { Button, Tabs, Layout } from "antd";
import {
  setNavbarVisible,
  setNavbarInVisible,
  setCompanyDetails,
} from "../actions";
import { useDispatch } from "react-redux";
import { openNotification} from "../utils/helpers";
import moment from "moment";
import { useSelector } from "react-redux";
import AppFooter from "../Components/Footer";
import http from "../api/client";
import { useJwt } from "react-jwt";
// require('dotenv').config()
const { Content } = Layout;

const { TabPane } = Tabs;

function Connect(prop) {
 
  const [data, setData] = useState();
  const [classAccounts, setClassAccounts] = useState([]);
  const [accountSettings, setAccountSettings] = useState();
  const [isShowedToast, setisShowedToast] = useState(false);
  const [isToShowToast, setisToShowToast] = useState(false);
  const [isUnauthorizeNotificationShowed, setIsUnauthorizeNotificationShowed] = useState(false);
  
  let history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const companyId = params.companyId;
  const [status, setstatus] = useState(-1);


  //  console.log("test env: ",process.env.REACT_APP_VAR2)
  
  
  useEffect(() => {
    if (isToShowToast) {
      if (!isShowedToast) {
        openNotification(
          "topRight",
          "Connection Successful!",
          "You have successfully connected to QuickBooks Online."
        );
        setisShowedToast(true);
        apiCallToUpdateStatusOfToastInDatabase();
      }
    }
  }, []);

  useEffect(() => {
    getQBOStatus();
  }, []);

  useEffect(() => {
    apiCallToGetAccounts();
  }, []);

  useEffect(() => {
    apiCallToGetAccountsSettings();
  }, []);

  useEffect(() => {
    apiCallToGetClassAccounts();
  }, []);

  useEffect(() => {
    getCompanyDetails();
  }, []);

  const getCompanyDetails = () => {
    http
      .get("/api/company/details?companyId=" + params.companyId)
      .then(async (res, err) => {
        const company = await res.data;
          
        dispatch(setCompanyDetails(company.data));
      })
      .catch((err) => {
        console.log("err in catch of accounts list in connect", err);
        
      });
  };

  const apiCallToGetClassAccounts = () => {
    http
      .get("/api/qbo/getClassAccounts?companyId=" + companyId)
      .then((res) => {
        setClassAccounts(res.data);
      })
      .catch((err) => {
        console.log("err in catch of Class accounts list", err);
         
      });
  };

  const apiCallToGetAccounts = () => {
    http
      .get("/api/qbo/getAllAccounts?companyId=" + companyId)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log("err in catch of accounts list", err);
        
      });
  };

  function apiCallToGetAccountsSettings() {
    http
      .get("/api/qbo/accountSettings?companyId=" + companyId)
      .then((res) => {
        setAccountSettings(res);
      })
      .catch((err) => {
        console.log("err in catch of accounts list", err);
         
      });
  }

  function getQBOStatus() { 
    http
      .get("/isQBOConnected?companyId=" + companyId)
      .then(function (response) {
        console.log("response in isQBOConnected: ", response);

        if (response.status === 200 && response.data) {

          const data = response.data;

          setstatus(data.qbo_connected);

          if (data.qbo_connected === 1) {
            dispatch(setNavbarVisible());
          } else {
            dispatch(setNavbarInVisible());
          }
          if (data.show_qbo_toast_msg) {
            setisToShowToast(true);
          }
           
          
        }else if (response.status === 401){
          console.log("user is not authorized in connect!")
        }
         
      })
      .catch((err) => {
        console.log("error in connect is:  **** ",err.message + " ****");
        
        setstatus(0);
        //user is not authorized
        if(err.response?.status === 401 ){
          HandleUnauthorizedUserFlow(err);
          }

          //network error
          if(err.message){
            openNotification(
              "topRight",
              "Unauthorized!",
              err.message,
              "error"
            );   
            return history.push('/unAuthorizedPage');
          } 

      });
  }

  function connectQBO(e) {
    window.open(
      QBO_APP_BASE_URL + "/oauthlogin.php?companyId=" + companyId,
      "_self"
    );
  }
  // function disconnectQBO(e) {
  //   window.open(
  //     QBO_APP_BASE_URL + "/revoketoken.php?companyId=" + companyId,
  //     "_self"
  //   );
  // }

  function apiCallToUpdateStatusOfToastInDatabase() {
    http
      .post( "/api/qbo/updateToastStatus", {
        companyId: companyId,
      })
      .then((res) => {})
      .catch((err) => {
        console.log("err in catch of insert into AccountSeetings", err);
        if(err.response.status === 401 ){
          HandleUnauthorizedUserFlow(err);
          }


      });
  }

  function HandleUnauthorizedUserFlow(err){
      if(!isUnauthorizeNotificationShowed){
        setIsUnauthorizeNotificationShowed(true);
        openNotification(
          "topRight",
          "Unauthorized!",
          err.response.data.message,
          "error"
        );         
      }
      history.push("/unAuthorizedUser");
      
    
  }




  return (
    <>
      <Layout>
        <Layout>
          <Content className="">
            <div>
              {/* <p>QBO Status: {status}</p> */}
              {status === -1 && <p>loading...</p>}

              {status === 0 && (
                <>
                  <div className="  h-screen   flex flex-col  ">
                    <div className="w-3/4 self-center mt-24 content-center">
                      <div className="">
                        <div className="flex justify-start font-bold text-base text-black_text_dark">
                          Welcome to QuickBooks Connection Page
                        </div>
                        <div className="flex justify-start font-normal text-gray_text_light text-xs mb-2">
                          You are currently not connected to QuickBooks Online
                        </div>
                        <div className=" bg-connectionBox_bg bg-opacity-10  border-2 w-full  inline-block align-middle py-10 px-24">
                          <div className="grid grid-cols-12 ">
                            <div className="col-span-4 flex content-center ">
                              <img
                                className="w-44 h-14"
                                alt="shopify "
                                src={require("../images/icons/shopify.png")}
                              ></img>
                            </div>
                            <div className="col-span-4   grid content-center justify-center">
                              <img
                                className="h-7 w-10"
                                alt="connection symbol"
                                src={require("../images/icons/connection_symbol.png")}
                              ></img>
                            </div>
                            <div className="col-span-4   flex content-end justify-end">
                              <img
                                className=" w-56 pt-4"
                                alt="quickbooks"
                                src={require("../images/icons/quickbooks_new.png")}
                              ></img>
                            </div>
                          </div>

                          <div className=" my-10   flex justify-center">
                            {/* <div className=" w-64  ">
                              <Button
                                type="primary"
                                size="large"
                                block
                                onClick={(e) => {
                                  connectQBO(e);
                                }}
                              >
                                Connect to QuickBooks
                                <img src={require("../images/icons/connectToQuickButton.png")} />
                              </Button>
                            </div> */}

                            <div className=" ">
                              <button
                                 
                               
                                 
                                onClick={(e) => {
                                  connectQBO(e);
                                }}
                              >
                                {/* Connect to QuickBooks */}
                                <img
                                  src={require("../images/icons/connectToQuickButton.png")}
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* QBO Setting Component imported if QBO is connected*/}
            {status === 1 && (
              <>
                <div className="w-full h-screen -mt-2.5 bg-white flex flex-col">
                  <div className="flex-1">
                    <Tabs
                      className="w-full"
                      defaultActiveKey="1"
                      tabBarExtraContent={
                        <div
                          className="flex gap-2 font-raleway"
                          style={{ marginRight: 51 }}
                        >
                          <img
                            src={require("../images/icons/sync_icon.png")}
                            alt="sync icon"
                          />
                          <span>Synchronization</span>
                          <span className="font-bold">
                            Start Date:{" "}
                            {moment(
                              accountSettings?.data.companySettings
                                .item_starting_date
                            )
                              .format("MM-DD-YYYY")
                              .toString()}
                          </span>
                        </div>
                      }
                    >
                      <TabPane
                        style={{
                          paddingLeft: 77,
                          paddingRight: 51,
                          paddingTop: 30,
                        }}
                        tab="Products"
                        key="1"
                        className=""
                      >
                        {/* Content of Tab Products  */}
                        {/* { company && ( <Connectivity company={company}/> )}  */}

                        <QboProductsAccountSettings
                          cogs={data?.cogs}
                          asset={data?.asset}
                          expense={data?.expense}
                          income={data?.income}
                          accountSettings={accountSettings?.data}
                          callBack={apiCallToGetAccounts}
                        />
                      </TabPane>

                      <TabPane
                        style={{
                          paddingLeft: 77,
                          paddingRight: 51,
                          paddingTop: 30,
                        }}
                        tab="Customers"
                        key="2"
                      >
                        {/* { company && ( <Connectivity company={company}/> )}  */}
                        <QboCustomerSettings
                          accountSettings={accountSettings?.data}
                        />
                      </TabPane>
                      <TabPane
                        style={{
                          paddingLeft: 77,
                          paddingRight: 51,
                          paddingTop: 30,
                        }}
                        tab="Orders"
                        key="3"
                      >
                        {/* { company && ( <Connectivity company={company}/> )}  */}
                        {/* Content of Orders  */}
                        <QboInvoiceAccountSettings
                          accountSettings={accountSettings?.data}
                          classAccounts={classAccounts.data}
                          deposite={data?.deposite}
                          callBack={apiCallToGetClassAccounts}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                  <div className="flex-none">
                    <AppFooter />
                  </div>
                </div>
              </>
            )}
          </Content>
        </Layout>
      </Layout>
    </>
  );
}

export default Connect;
